import React from 'react';

import { AuLinkList } from 'components/DTA';

import './AuBreadcrumbs.scss';

interface IAuBreadcrumbs {
  label: string;
  items: Array<IAuBreadcrumbItem>;
  className?: string;
  dark?: boolean;
  attributeOptions?: any;
  style?: React.CSSProperties;
}

export interface IAuBreadcrumbItem {
  link?: string;
  text: string | React.ReactNode;
}

/**
 * DEFAULT
 * The breadcrumbs component
 */
const AuBreadcrumbs: React.FC<IAuBreadcrumbs> = ({ dark, label, items, className = '', ...attributeOptions }) => (
  <nav
    className={`au-breadcrumbs ${className} ${dark ? 'au-breadcrumbs--dark' : ''}`}
    aria-label={label}
    {...attributeOptions}
  >
    <AuLinkList inline items={items} />
  </nav>
);

export default AuBreadcrumbs;
